/* eslint-disable import/prefer-default-export */
import { $form, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';
import displayNotification from 'utils/displayNotification';
import { auth } from 'utils/firebase';
import { sendPasswordResetEmail } from 'firebase/auth';

export const handleSubmitResetPassword = async () => {
  $form.loadingStart();
  try {
    await sendPasswordResetEmail(auth, $form.value.email);
    $view.update({ modal: null });
    displayNotification({ title: 'Success!', message: 'Please check your email for next steps' });
  } catch (error) {
    const message = error.code === 'auth/user-not-found'
      ? 'User not found. Please check the email and try again.'
      : 'Failed to send password reset email. Please try again.';
    displayError({
      title: 'Password Reset Error',
      message,
    });
  } finally {
    $form.loadingEnd();
  }
};
